module.exports = __webpack_public_path__ + "img/complete_task.3ef3efb.svg";